// Kept in a leaf module: useFilterOptions reads it at load time, and taking it
// from DealsToolbar put that hook inside an import cycle through the deals page.
export enum NumericCondition {
  GT = "gt",
  LT = "lt",
  EQ = "eq",
  BETWEEN = "between"
}
